export const Mode = {
  FILLED: 'filled',
  BEZELED: 'bezeled',
  PLAIN: 'plain',
  GRAY: 'gray',
  OUTLINE: 'outline',
  WHITE: 'white',
  /**
   * ℹ️ Кастомное значение
   */
  LINK: 'link',
} as const;

export type Mode = Union<typeof Mode>;

export const Size = {
  SMALL: 's',
  MEDIUM: 'm',
  LARGE: 'l',
} as const;

export type Size = Union<typeof Size>;

export const LoadingType = {
  SPINNER: 'spinner',
  SHINE: 'shine',
} as const;

export type LoadingType = Union<typeof LoadingType>;
